import { render } from "./StatsPage.vue?vue&type=template&id=5ef668f6"
import script from "./StatsPage.vue?vue&type=script&lang=js"
export * from "./StatsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__